/**
 * Web composer: Enter sends, Shift+Enter inserts a newline, and keys pressed
 * while an IME is composing (e.g. Turkish/Japanese input methods) never send
 * (de-slop CHAT-25). Pure so it can be unit-tested.
 */
export interface ComposerKeyEvent {
  key?: string;
  shiftKey?: boolean;
  altKey?: boolean;
  ctrlKey?: boolean;
  metaKey?: boolean;
  isComposing?: boolean;
  keyCode?: number;
}

export function shouldSendOnKey(event: ComposerKeyEvent | null | undefined): boolean {
  if (!event || event.key !== 'Enter') return false;
  if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) return false;
  if (event.isComposing || event.keyCode === 229) return false;
  return true;
}
